import moment from 'moment-timezone';

const getNumStr = (input) => {
  const num = 100 + Math.abs(input);
  return `${num}`.substr(1);
};

const getOffsetString = (offset) => {
  const hours = Math.floor(offset / 60);
  const min = offset % 60;
  const sign = offset < 0 ? '-' : '+';

  return `${sign}${getNumStr(hours)}:${getNumStr(min)}`;
};

export const getTimezoneListByCountry = (needleCountryCode, countries, timezones) => {
  const needleCountry = countries.find(({ value }) => value === needleCountryCode);
  return timezones
    .filter(({ countryId }) => (needleCountry ? countryId === needleCountry.id : true))
    .map(({ name, utcOffset }) => ({
      value: name,
      label: `GMT${getOffsetString(utcOffset)} - ${name}`,
    }));
};

export const getTimezoneListByOffset = (start, end, timezones) => {
  return timezones
    .filter(({ utcOffset }) => {
      const hours = Math.floor(utcOffset / 60);
      return hours >= start && hours <= end;
    })
    .map(({ id, name, utcOffset }) => ({
      value: id,
      label: `GMT${getOffsetString(utcOffset)} - ${name}`,
    }));
};

const decimalToTime = (timezone) => {
  let decimalTime = parseFloat(timezone);
  decimalTime = decimalTime * 60 * 60;
  const hours = Math.floor(decimalTime / (60 * 60));
  decimalTime -= hours * 60 * 60;
  let minutes = Math.floor(decimalTime / 60);

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  return `${hours > 0 ? `+${hours}` : hours}:${minutes}`;
};

export const convertToUTC = (timezone) => {
  if (!timezone) {
    return null;
  }
  if (timezone.utcOffset !== 0) {
    return `${timezone.popularName || timezone.name} (UTC${decimalToTime(
      parseInt(timezone.utcOffset, 10) / 60,
    )})`;
  }
  return `${timezone.popularName || timezone.name} (UTC${decimalToTime(
    parseInt(timezone.dstOffset, 10) / 60,
  )})`;
};

export const getUTCTimezoneLabel = (timezoneName, utcOffsetInMinutes) => {
  const utcOffsetInHours = Math.floor(utcOffsetInMinutes / 60);
  const modulatedOffset = utcOffsetInHours >= 0 ? `+${utcOffsetInHours}` : utcOffsetInHours;
  const label = `UTC${modulatedOffset}:${utcOffsetInMinutes % 60 || '00'} ${timezoneName}`;
  return label;
};

export const getFullUTCOffset = (utcOffSet) => {
  if (!utcOffSet) {
    return '';
  }
  const fullUTCOffset = utcOffSet / 60;
  const prefix = `${fullUTCOffset}`.substring(0, 1) === '-' ? '' : '+';
  return `UTC${prefix}${fullUTCOffset}:00`;
};

export const toAmPM = (time) => {
  if (!time) {
    return;
  }
  const [hours, mins] = time.split(':');
  if (+hours === 0) {
    return `12:${mins} AM`;
  }
  if (hours < 12) {
    return `${+hours}:${mins} AM`;
  }
  if (hours === 12) {
    return `${hours}:${mins} PM`;
  }
  return `${hours - 12}:${mins} PM`;
};

export const fromPSTToLocalTimeClosure = (utcTimezone) => (pstTime) => {
  let timeFormatBuilder = moment.tz(`2000-01-01T${pstTime}`, 'America/Los_Angeles');
  if (utcTimezone) {
    timeFormatBuilder = timeFormatBuilder.tz(utcTimezone);
  }
  return toAmPM(timeFormatBuilder.format('HH:mm'));
};

export const fromLocalTimeToPSTClosure = (utcTimezone) => (localTime) => {
  if (!utcTimezone) {
    return null;
  }
  let timeFormatBuilder = moment.tz(`2000-01-01T${localTime}`, utcTimezone);
  timeFormatBuilder = timeFormatBuilder.tz('America/Los_Angeles');
  return toAmPM(timeFormatBuilder.format('HH:mm'));
};

export const convertTimezoneClosure = (fromTimezone, toTimezone) => (time) => {
  if (!fromTimezone || !toTimezone) {
    return null;
  }
  let timeFormatBuilder = moment.tz(`2000-01-01T${time}`, fromTimezone);
  timeFormatBuilder = timeFormatBuilder.tz(toTimezone);
  return toAmPM(timeFormatBuilder.format('HH:mm'));
};
